import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=cd31211a&scoped=true&lang=pug"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeForm.vue?vue&type=style&index=0&id=cd31211a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd31211a",
  null
  
)

export default component.exports